export const localDevApiBaseUrl = 'http://127.0.0.1:5001/v1/api'
export const sameOriginApiBaseUrl = '/v1/api'

export type RuntimeEnv = Readonly<Record<string, string | boolean | undefined>>

/**
 * 解析前端运行时配置。
 * 本地 Vite dev server 直连 api-v2；生产构建固定走同源 `/v1/api`，由 nginx / Ingress 反代。
 */
export function resolveApiBaseUrl(env: RuntimeEnv = import.meta.env) {
  if (env.MODE === 'test') {
    return sameOriginApiBaseUrl
  }

  if (env.DEV === true || env.MODE === 'development') {
    return localDevApiBaseUrl
  }

  return sameOriginApiBaseUrl
}

export const runtimeConfig = {
  apiBaseUrl: resolveApiBaseUrl(),
} as const
